import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "./App.css";
import NaxosLandingPage from "./Pages/Landing";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import DeleteAccount from "./Pages/DeleteAccount";
import ChildSafetyStandards from "./Pages/ChildSafetyStandards";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: true,
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    // Make available globally for components that trigger scroll actions.
    window.lenis = lenis;

    return () => {
      if (window.lenis) {
        window.lenis.destroy();
        delete window.lenis;
      }
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Main Landing Page */}
          <Route path="/" element={<NaxosLandingPage />} />

          {/* Legal Pages */}
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/delete-account" element={<DeleteAccount />} />
          {/* Child Safety Standards Pages */}
          <Route
            path="/child-safety-standards"
            element={<ChildSafetyStandards />}
          />
          <Route path="/case-policy" element={<ChildSafetyStandards />} />
          <Route path="/child-protection" element={<ChildSafetyStandards />} />
          {/* 404 Page - Optional */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

// Simple 404 Component
const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-semibold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Page not found</p>
        <a
          href="/"
          className="bg-[#FEF200] hover:bg-yellow-500 text-black font-semibold py-3 px-6 rounded-full transition-colors duration-200"
        >
          Go Home
        </a>
      </div>
    </div>
  );
};

export default App;
